export enum UserRoleEnum {
  ADMIN = 'ADMIN',
  PROSECUTOR = 'PROSECUTOR',
  SUPERVISOR = 'SUPERVISOR',
  NEWS_ADMIN = 'NEWS_ADMIN',
  OMBUDSMAN = 'OMBUDSMAN',
  OPEN_PART = 'OPEN_PART',
  SUPERIOR_PROSECUTOR = 'SUPERIOR_PROSECUTOR',
}
